<template>
    <v-app>
      <!-- Aviso Freemium -->
      <v-system-bar v-if="isFreemium && !demoExpired && demoEndDateFormatted" app color="warning" dark class="justify-center font-weight-bold" style="font-size: 14px; z-index: 10;">
        <v-icon class="mr-1 mr-sm-2" small>mdi-alert-circle-outline</v-icon>
        <span class="d-none d-sm-inline">Seu período de testes acaba em&nbsp;</span>
        <span class="d-inline d-sm-none">Testes até&nbsp;</span>
        {{demoEndDateFormatted}}
        <span class="mx-1 mx-sm-2">|</span>
        <a @click.prevent="showSaibaMaisDialog = true" href="#" style="color: white; text-decoration: underline; cursor: pointer;">
          Saiba mais
        </a>
      </v-system-bar>

      <!-- Barra de navegação -->
      <v-app-bar app class="vs-app-bar" elevation="0">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" color="#ffffff"></v-app-bar-nav-icon>
        <div class="d-flex align-center ml-2 ml-sm-4 cursor-pointer" @click="$router.push(isKitTemfc ? '/webapp/questionssimulado' : '/webapp/questionsupdatedsup')" style="cursor: pointer;">
          <img src="/veriSalvatori/logo_site.svg" alt="Veri Salvatori" style="height: 24px; width: auto; max-width: 180px; object-fit: contain;" />
          <div class="d-none d-md-flex flex-column ml-3 pl-3" style="border-left: 1px solid rgba(255,255,255,0.18); line-height: 1.1;">
            <span style="font-family: 'Inter', sans-serif; font-size: 8px; font-weight: 600; letter-spacing: 0.28em; color: #a5bada; text-transform: uppercase;">INSTITUTO MÉDICO</span>
          </div>
        </div>

        <v-spacer></v-spacer>

        <!-- Adicionando campo para o nome da pessoa à direita com estilo refinado -->
        <div class="vs-header-user d-flex align-center px-3 py-1 mr-2 mr-sm-4">
          <v-avatar size="28" color="rgba(83, 126, 251, 0.2)" class="mr-2">
            <v-icon size="18" color="#83b2ff">mdi-account</v-icon>
          </v-avatar>
          <span class="vs-user-name text-truncate" style="max-width: 180px; font-size: 13px; font-weight: 500; color: #ffffff;">{{userName}}</span>
        </div>
      </v-app-bar>

      <!-- Diálogo de expiração da versão trial -->
      <v-dialog v-model="demoExpired" max-width="500" persistent>
        <v-card class="pa-4 rounded-xl vs-card-light">
          <v-card-title class="text-center py-4" style="background: linear-gradient(135deg, #b91c1c, #ef4444); color: white; font-weight: bold; font-size: 1.4rem; border-radius: 16px 16px 0 0;">
            <v-icon large color="white" class="mr-2 mb-1">mdi-clock-alert-outline</v-icon>
            Tempo Esgotado
          </v-card-title>

          <v-card-text class="text-center mt-6" style="font-size: 1.05rem; line-height: 1.6; color: #333;">
            <p>Seu período de teste de 7 dias chegou ao fim.</p>
            <p class="mt-2 font-weight-bold" style="color: var(--vs-text-dark);">Esperamos que tenha aproveitado a experiência na Veri Salvatori!</p>
            <p class="mt-4" style="font-size: 0.95rem;">
              Fale conosco pelo link: <a href="https://verisalvatori.com.br/comercial" target="_blank" style="color: #315fd8; text-decoration: underline; font-weight: 600;">verisalvatori.com.br/comercial</a>
            </p>
          </v-card-text>

          <v-card-actions class="justify-center mt-4 mb-2 flex-wrap">
            <v-btn
              color="primary"
              variant="elevated"
              class="px-6 mb-3 mx-2 vs-btn-primary"
              style="color: white !important; font-weight: bold; text-transform: none; font-size: 1rem;"
              elevation="2"
              :href="subscriptionLink"
              target="_blank"
            >
              <v-icon left>mdi-credit-card-outline</v-icon>
              Assine Agora
            </v-btn>
            <v-btn
              color="error"
              variant="outlined"
              class="px-6 mb-3 mx-2"
              style="font-weight: bold; text-transform: none; font-size: 1rem; border-radius: 12px;"
              @click="logout"
            >
              <v-icon left>mdi-logout</v-icon>
              Sair da Conta
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo Saiba Mais (Acesso Limitado) -->
      <v-dialog v-model="showSaibaMaisDialog" max-width="500">
        <v-card class="pa-4 rounded-xl vs-card-light">
          <v-card-title class="text-center py-4" style="background: linear-gradient(135deg, #05122e 0%, #315fd8 100%); color: white; font-weight: bold; font-size: 1.4rem; border-radius: 16px 16px 0 0;">
            <v-icon large color="white" class="mr-2 mb-1">mdi-information-outline</v-icon>
            Acesso Limitado
          </v-card-title>

          <v-card-text class="text-center mt-6" style="font-size: 1.05rem; line-height: 1.6; color: #333;">
            <p>Durante seu período de testes, você tem acesso <strong>LIMITADO</strong> ao banco de questões e simulados da Veri Salvatori.</p>
            <p class="mt-2" style="color: #647089;">Para acessar o conteúdo completo com resoluções comentadas e métricas detalhadas, assine agora.</p>
          </v-card-text>

          <v-card-actions class="justify-center mt-4 mb-2 flex-wrap">
            <v-btn
              color="primary"
              variant="elevated"
              class="px-6 mb-3 mx-2 vs-btn-primary"
              style="color: white !important; font-weight: bold; text-transform: none; font-size: 1rem;"
              elevation="2"
              :href="subscriptionLink"
              target="_blank"
            >
              <v-icon left>mdi-credit-card-outline</v-icon>
              Assine Agora
            </v-btn>
            <v-btn
              color="grey darken-1"
              variant="text"
              class="px-6 mb-3 mx-2"
              style="font-weight: bold; text-transform: none; font-size: 1rem;"
              @click="showSaibaMaisDialog = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo de seleção de admin quando o valor contém múltiplas opções separadas por vírgula -->
      <v-dialog v-model="showAdminSelectDialog" max-width="800" persistent>
        <v-card class="pa-4 rounded-xl vs-card-light">
          <v-card-title class="text-center py-4" style="background: linear-gradient(135deg, #05122e 0%, #315fd8 100%); color: white; font-weight: bold; font-size: 1.4rem; border-radius: 16px 16px 0 0;">
            👤 Escolha seu perfil
          </v-card-title>

          <v-card-text class="text-center" style="font-size: 1.1rem; line-height: 1.6;">
            <p>Selecione um perfil para continuar.</p>
            <v-radio-group v-model="selectedAdmin" dense class="mt-4">
              <v-radio
                v-for="option in adminOptions"
                :key="option"
                :label="getAdminDisplayLabel(option)"
                :value="option"
                color="primary"
                class="mb-2"
              />
            </v-radio-group>
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
              color="primary"
              variant="elevated"
              class="mx-2 px-6 vs-btn-primary"
              style="color: white !important; font-weight: bold;"
              :disabled="!selectedAdmin"
              @click="confirmAdminSelection"
            >
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Barra lateral (navigation drawer) -->
      <v-navigation-drawer app v-model="drawer" class="vs-drawer" width="280">
        <v-list dense class="pt-4">
          <v-list-item v-if="!isTecm && !isKitTemfc" link to="/webapp/questionschallenge">
            <v-list-item-icon>
              <v-icon>mdi-trophy-award</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Desafio 150 Questões</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item link to="/webapp/questionsupdated">
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Treinar Questões</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          
          <v-list-item v-if="!isKitTemfc" link to="/webapp/questionsupdatedsup">
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Treinar Questões</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="!isKitTemfc" link to="/webapp/questionsresults">
            <v-list-item-icon>
              <v-icon>mdi-chart-donut</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Métricas Questões</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/webapp/questionssimulado">
            <v-list-item-icon>
              <v-icon>mdi-book-open-page-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Simulados</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/webapp/simuladosresults">
            <v-list-item-icon>
              <v-icon>mdi-chart-histogram</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Métricas Simulados</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item link to="/webapp/questionsupdated">
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Treinar Questões2</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/webapp/questionsquiz">
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Treinar Questões4</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->




<!-- 
          <v-list-item link to="/webapp/questionsresultssup">
            <v-list-item-icon>
              <v-icon>mdi-chart-donut</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Métricas Questões Sup</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

          

          <v-list-item v-if="!isTecm || isAdmin" link to="/webapp/questionsanswers">
            <v-list-item-icon>
              <v-icon>mdi-book</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Gabarito Simulados</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
<!-- v-if="dbName == 'TEMFC'" -->
          <v-list-item v-if="!isTecm && !isKitTemfc" link to="/webapp/decks">
            <v-list-item-icon>
              <v-icon>mdi-cards</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Decks Flashcards</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item v-if="!isTecm && !isKitTemfc" link to="/webapp/decksv2">
            <v-list-item-icon>
              <v-icon>mdi-cards-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Deck Flashcards 2.0</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->


          <!-- v-if="dbName == 'TEMFC'" -->
          <!-- Botão para rota "Results" -->
          <v-list-item v-if="!isTecm && !isKitTemfc" link to="/webapp/results">
            <v-list-item-icon>
              <v-icon>mdi-chart-timeline-variant-shimmer</v-icon>
            </v-list-item-icon>
            <v-list-item-content> 
              <v-list-item-title>Métricas Flashcards</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item v-if="!isTecm && !isKitTemfc" link to="/webapp/resultsv2">
            <v-list-item-icon>
              <v-icon>mdi-chart-timeline-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content> 
              <v-list-item-title>Métricas Flashcards 2.0</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
  
          <!-- Botão para rota "About" -->
          <v-list-item link to="/webapp/profile">
            <v-list-item-icon>
              <v-icon>mdi-account-edit</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Usuário</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="adminOptions.length > 1" @click="openAdminSelectDialog">
            <v-list-item-icon>
              <v-icon>mdi-account-switch</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Trocar Perfil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="isAdmin && !isTecm" link to="/webapp/questionsadmin">
            <v-list-item-icon>
              <v-icon>mdi-monitor-edit</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Admin Questões</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="isAdmin && !isTecm" link to="/webapp/consolidatedmetrics">
            <v-list-item-icon>
              <v-icon>mdi-chart-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Métricas Consolidadas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <!-- Botão para rota "About" -->
          <v-list-item v-if="!isTecm && !isKitTemfc" link to="/webapp/about">
            <v-list-item-icon>
              <v-icon>mdi-information</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Info Flashcards</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <!-- Botão de logout fixado na parte inferior com slot append -->
        <template #append>
          <div class="pa-2 vs-drawer-append">
            <v-list-item @click="logout" class="vs-drawer-logout-item">
              <v-list-item-icon>
                <v-icon color="#f87171">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="color: #f87171; font-weight: 600;">Sair da Conta</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
      </v-navigation-drawer>
  
      <!-- Conteúdo principal -->
      <v-main>
        <router-view></router-view>
      </v-main>
  
      <!-- Rodapé -->
      <v-footer app class="vs-footer d-flex justify-space-between align-center px-6">
        <div class="d-flex align-center flex-wrap">
          <img src="/veriSalvatori/WHITE_LOGO_ONLY.png" alt="VS" style="height: 16px; width: auto; margin-right: 8px; opacity: 0.85;" />
          <span>&copy; 2026 Instituto Médico Veri Salvatori</span>
          <span class="ml-2 px-2 py-0.5" style="font-size: 11px; font-weight: 600; letter-spacing: 0.04em; color: #83b2ff; background: rgba(83, 126, 251, 0.12); border: 1px solid rgba(131, 178, 255, 0.2); border-radius: 6px;">v{{ appVersion }}</span>
        </div>
      </v-footer>

      <!-- Modal de Boas Vindas Freemium -->
      <FreemiumWelcomeDialog 
        :dialogVisible="showFreemiumWelcome" 
        @close="showFreemiumWelcome = false" 
      />
    </v-app>
  </template>
  
  <script>
  import { db, auth } from '../main';
  import { collection, query, where, getDocs } from 'firebase/firestore';
  import FreemiumWelcomeDialog from '../components/Shared/FreemiumWelcomeDialog.vue';
  import packageInfo from '../../package.json';
  
  export default {
    components: {
      FreemiumWelcomeDialog,
    },
    data() {
      return {
        drawer: false,
        componentMounted: false,
        showAdminSelectDialog: false,
        showSaibaMaisDialog: false,
        adminOptions: [],
        selectedAdmin: null,
        demoExpired: false,
        demoEndDateFormatted: '',
        showFreemiumWelcome: false,
        appVersion: packageInfo.version,
      };
    },

    mounted() {
      this.$nextTick(() => {
        this.loadInitialDataAfterAdminSelection();
      });
    },

    watch: {
      $route(to) {
        this.redirectIfKitRestricted(to.path);
      },

},

    computed:{
      isKitTemfc() {
        const a = (this.$store.getters.admin || '').toLowerCase().trim();
        return [
          'kit_temfc',
          'kit_temfcadmin',
          'kit_temfc_admin',
          'kit-temfc',
          'kit-temfcadmin',
          'kit-temfc-admin',
          'kittemfc',
          'kittemfcadmin'
        ].includes(a);
      },
      isTecm() {
        const a = this.$store.getters.admin;
        return a === 'tecmadmin' || a === 'tecm';
      },
      userName: function () {
        // Verifica se this.$store.getters.userName não é undefined ou null
        if (this.$store.getters.userName !== undefined && this.$store.getters.userName !== null) {
            // Verifica se this.$store.getters.userName é um array e possui pelo menos um elemento
            if (Array.isArray(this.$store.getters.userName) && this.$store.getters.userName.length > 0) {
                // Retorna o nome do primeiro elemento do array
                return this.$store.getters.userName[0].firstName;
            } else {
                // Trate o caso em que this.$store.getters.userName é um array vazio
                return '';
            }
        } else {
            // Trate o caso em que this.$store.getters.userName é undefined ou null
            return '';
        }
    },
    isAdmin() {
      return this.$store.getters.admin === 'temfcadmin' || this.$store.getters.admin === 'agsusadmin'|| this.$store.getters.admin === 'tecmadmin' || this.$store.getters.admin === 'kit_temfcadmin';
    },
    isFreemium() {
      return this.$store.getters.freemium === 'true' || this.$store.getters.freemium === true;
    },
    subscriptionLink() {
      if (this.isTecm) {
        return 'http://medexperts.com.br/tecm-qbank/';
      } else {
        return 'https://medexperts.com.br/temfc/';
      }
    },
    dbName: function () {
          return this.$store.getters.dbName;
       },
    },
    methods: {
      async loadInitialDataAfterAdminSelection() {
        await this.$store.dispatch('checkAdmin');

        const freemiumStatus = this.$store.getters.freemium;
        console.log("Status Freemium:", freemiumStatus);

        if (this.isFreemium) {
          if (!sessionStorage.getItem('freemiumWelcomeShown')) {
            this.showFreemiumWelcome = true;
            sessionStorage.setItem('freemiumWelcomeShown', 'true');
          }
          await this.checkFreemiumExpiration();
        }

        if (this.requiresAdminSelection()) {
          this.tryOpenAdminSelectDialog();
          return;
        }

        this.initializeAppData();
        this.redirectIfKitRestricted();
      },
      redirectIfKitRestricted(path) {
        if (!this.isKitTemfc) return;
        const current = (path || this.$route.path || '').toLowerCase();
        const forbiddenForKit = [
          '/webapp/questions',
          '/webapp/questionsupdated',
          '/webapp/questionsupdatedsup',
          '/webapp/questionsv2',
          '/webapp/questionschallenge',
          '/webapp/questionsresults',
          '/webapp/questionsresultssup',
          '/webapp/questionsquiz',
          '/webapp/questionsquizchallenge',
          '/webapp/decks',
          '/webapp/decksv2',
          '/webapp/decks2',
          '/webapp/flashcards',
          '/webapp/flashcardsv2',
          '/webapp/flashcards2',
          '/webapp/results',
          '/webapp/resultsv2',
          '/webapp/results2',
          '/webapp/about',
          '/webapp/home'
        ];
        if (forbiddenForKit.includes(current)) {
          this.$router.replace('/webapp/questionssimulado');
        }
      },
      requiresAdminSelection() {
        const adminValue = this.$store.getters.admin;
        return typeof adminValue === 'string' && adminValue.includes(',');
      },
      initializeAppData() {
        this.$store.dispatch('checkExistingUser');
        this.$store.dispatch('getCards');
        this.$store.dispatch('loadItems');
      },
      logout() {
        this.$store.dispatch('logout').then(() => {
           this.$router.push('/')
          }); 
      },
      async checkFreemiumExpiration() {
        try {
          if (!auth.currentUser) return;
          const userEmail = auth.currentUser.email;
          const usersRef = collection(db, 'users');
          const q = query(usersRef, where('email', '==', userEmail));
          const querySnapshot = await getDocs(q);
          
          if (!querySnapshot.empty) {
            querySnapshot.forEach((docSnap) => {
              const data = docSnap.data();
              if (data.demoStartDate) {
                let startDate = data.demoStartDate.toDate ? data.demoStartDate.toDate() : new Date(data.demoStartDate);
                
                const endDate = new Date(startDate);
                endDate.setDate(endDate.getDate() + 7);
                
                const now = new Date();
                
                if (now > endDate) {
                  this.demoExpired = true;
                }
                
                const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
                this.demoEndDateFormatted = endDate.toLocaleDateString('pt-BR', options).replace(',', ' às');
              }
            });
          }
        } catch (error) {
          console.error("Erro ao verificar expiração do freemium:", error);
        }
      },
      check() {
        this.$store.dispatch('checkExistingUser').then(() => {
          // this.$router.push('/')
          }); 
             //console.log("Logout executado");
      },
      openAdminSelectDialog() {
        this.selectedAdmin = this.$store.getters.admin;
        this.showAdminSelectDialog = true;
      },
      tryOpenAdminSelectDialog() {
        const adminValue = this.$store.getters.admin;
        if (typeof adminValue === 'string' && adminValue.includes(',')) {
          const options = adminValue
            .split(',')
            .map(option => option.trim())
            .filter(option => option.length > 0);

          if (options.length > 1) {
            this.adminOptions = options;
            this.selectedAdmin = options[0];
            this.showAdminSelectDialog = true;
          }
        }
      },
      getAdminDisplayLabel(option) {
        const normalized = (option || '').toLowerCase().trim();
        const labels = {
          temfc: 'TEMFC',
          temfcadmin: 'TEMFC Admin',
          tecm: 'TECM',
          tecmadmin: 'TECM Admin',
          kit_temfc: 'KIT TEMFC',
          kit_temfcadmin: 'KIT TEMFC Admin',
          kit_temfc_admin: 'KIT TEMFC Admin',
          'kit-temfc': 'KIT TEMFC',
          'kit-temfcadmin': 'KIT TEMFC Admin',
          'kit-temfc-admin': 'KIT TEMFC Admin',
          kittemfc: 'KIT TEMFC',
          kittemfcadmin: 'KIT TEMFC Admin'
        };

        return labels[normalized] || option;
      },
      confirmAdminSelection() {
        if (!this.selectedAdmin) return;
        this.$store.commit('setAdmin', this.selectedAdmin);
        this.showAdminSelectDialog = false;
        this.initializeAppData();
        this.redirectIfKitRestricted();
      }
    }
  };
  </script>

  <style scoped>
  .vs-header-user {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 20px;
    backdrop-filter: blur(10px);
    transition: background 0.2s;
  }

  .vs-header-user:hover {
    background: rgba(255, 255, 255, 0.14);
  }

  .cursor-pointer {
    cursor: pointer;
  }
  </style>
  